import React from 'react';
import { PropTypes } from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import './PersonalInfo.scss';
import CardWithTitleButton from '../../card-widget/CardWithTitleButton'
import { RouteConstants } from "../../route/services/RouteConstants";
import PersonalInfoBlock from './PersonalInfoBlock';
import PersonalInfoEdit from './PersonalInfoEdit';
import ActionButton from '../../button/ActionButton';

const PersonalInformation = (props) => {
    let { onEdit, profile, lang, profileUpdated } = props;
    let isEditing = props.location.pathname === RouteConstants.EDIT_PERSONAL_INFO;
    let isDisabled = props.location.pathname !== RouteConstants.PROFILE &&
        props.location.pathname !== RouteConstants.EDIT_PERSONAL_INFO;
    let buttonLabel = isEditing ? '' : 'profile.personal_info.edit_button';
    return (
        <CardWithTitleButton onTitleButtonClick={onEdit} titleKey='profile.personal_info.title' isDisabled={isDisabled}
            buttonLabelKey={buttonLabel} buttonClass="hrb-profile-button">
            <Switch>
                <Route path={RouteConstants.EDIT_PERSONAL_INFO} render={(props) => (
                    <PersonalInfoEdit {...props} profile={profile} lang={lang} profileUpdated={profileUpdated} />
                )} />
                <Route path='*' render={(props) => (
                    <PersonalInfoBlock {...props} profile={profile} lang={lang}  />)} />
            </Switch>
            {buttonLabel &&
                <ActionButton text={buttonLabel} onClick={onEdit} buttonClass="hrb-profile-secondary-button" disabled={Boolean(isDisabled)}/>
            }
        </CardWithTitleButton>
    );
}

PersonalInformation.propTypes = {
    onEdit: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    profileUpdated: PropTypes.func.isRequired
};

export default withRouter(PersonalInformation);